export default "__VITE_ASSET__gDlk4nEZ__"